import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=8500b5d2&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=8500b5d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8500b5d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8500b5d2')) {
      api.createRecord('8500b5d2', component.options)
    } else {
      api.reload('8500b5d2', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=8500b5d2&scoped=true&", function () {
      api.rerender('8500b5d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26mCb7bH5dRMd/JS/comp/CookieBox.vue"
export default component.exports